module.exports = __webpack_public_path__ + "static/media/tele2.0a59cf48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/tele2.svg
// module id = 888
// module chunks = 7